import get from "lodash/get";
import isNumber from "lodash/isNumber";
import {RegisterOptions, useFormContext} from "react-hook-form";

import {InputField, InputFieldProps} from "@/components/form/fields/InputField/InputField.tsx";
import {Input} from "@/components/input/Input.tsx";
import {getRequiredError} from "@/pages/checks/components/form/constants.ts";

export interface NumberInputFieldProps extends InputFieldProps {}

export const NumberInputField = ({name, required, ...rest}: NumberInputFieldProps) => {
  const {
    register,
    formState: {defaultValues},
  } = useFormContext();
  const defaultValue = get(defaultValues, name);
  const options: RegisterOptions = {};
  if (required) {
    options.required = getRequiredError(name);
  }
  if (isNumber(defaultValue)) {
    options.valueAsNumber = true;
  }
  return (
    <InputField
      name={name}
      required={required}
      {...rest}
      input={<Input type="number" {...register(name, options)} />}
    />
  );
};
